module.exports = __webpack_public_path__ + "static/payresult.cba42817.gif";